const RoutesToPages = {
    homePage: '/',
    deleteItem: 'acceptDeleteContact',
    change: 'changeContact',
    addItem: 'newContact',
    view: 'contactInfo/'
};

export default RoutesToPages;